module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1258.f64ed9d9.png";